import { render } from "./TTextarea.vue?vue&type=template&id=2f870430&scoped=true"
import script from "./TTextarea.vue?vue&type=script&lang=js"
export * from "./TTextarea.vue?vue&type=script&lang=js"

import "./TTextarea.vue?vue&type=style&index=0&id=2f870430&lang=scss&scoped=true"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f870430"]])

export default __exports__